<template>
  <div class="app-header">
    <div class="header-title">云志影藏后台管理系统</div>
    <div class="info-view">
      <div class="jk-mr-10">{{ $store.state.userName }}</div>
      <el-button @click="logout" type="text" size="mini">退出</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  created() {
    console.log(this.$store.state);
  },
  methods: {
    logout() {
      this.$store.commit("logout");
      this.$router.push("/login");
    },
  },
};
</script>

<style lang="scss" scoped>
.app-header {
  width: 100%;
  height: 60px;
  border-bottom: solid #eee 1px;
  display: flex;
  padding-left: 60px;
  padding-right: 60px;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
}
.header-title {
  font-weight: bold;
}
.info-view {
  display: flex;
  align-items: center;
}
</style>